import { getGetters } from '@/store/getters'
import { getMutations } from '@/store/mutations'
import { getActions } from '@/store/actions'
import { Request as model } from '@/models/api_v1'
import { PatientRequestService as service } from '@/services/api_v1/patient'

// Init
const getInitialState = () => ({
  isInit: null,
  items: null,
  itemsMap: {},
  itemInit: model.initialState(),
});

// Import
const getters = getGetters()
const mutations = getMutations({ model })
const actions = {
  ...getActions({ model, service, init: getInitialState() }),
  async substrate({ state, commit, dispatch }) {
    let output = null
    try {
      output = await service.substrate()
    } catch (error) {
      toast({ msg: error })
      output = error
    } finally {
      return output
    }
  },
  async returnConfirm({ state, commit, dispatch }) {
    let output = null
    try {
      output = await service.returnConfirm()
    } catch (error) {
      toast({ msg: error })
      output = error
    } finally {
      return output
    }
  },
}

// Export
export default {
  namespaced: true,
  state: getInitialState(),
  getters,
  mutations,
  actions
}
